import type { ColorScheme } from '@/stores/settings'

export const colorSchemes: ColorScheme[] = [
	{
		id: 'default',
		name: 'Default',
		light: {
			// Primary colors
			primaryHue: 42,
			primary: 'oklch(0.43 0.04 42.00)',
			primaryForeground: 'oklch(1.00 0 0)',
			secondary: 'oklch(0.92 0.07 76.67)',
			secondaryHue: 76.67,
			secondaryForeground: 'oklch(0.35 0.07 41.41)',
			// Background colors
			background: 'oklch(0.97 0.005 80)',
			foreground: 'oklch(0.24 0 0)',
			card: 'oklch(0.98 0.004 80)',
			cardForeground: 'oklch(0.24 0 0)',
			// Accent colors
			accent: 'oklch(0.94 0.005 80)',
			accentForeground: 'oklch(0.24 0 0)',
			muted: 'oklch(0.94 0.005 80)',
			mutedForeground: 'oklch(0.55 0.01 60)',
			// Border & input
			border: 'oklch(0.92 0.003 80)',
			input: 'oklch(0.92 0.003 80)',
			ring: 'oklch(0.43 0.04 42.00)',
			// Sidebar colors
			sidebar: 'oklch(0.99 0.003 80)',
			sidebarBg: 'oklch(0.90 0.005 80)',
			sidebarForeground: 'oklch(0.26 0 0)',
			sidebarPrimary: 'oklch(0.33 0 0)',
			sidebarPrimaryForeground: 'oklch(0.99 0 0)',
			sidebarAccent: 'oklch(0.92 0.005 80)',
			sidebarAccentForeground: 'oklch(0.33 0 0)',
			sidebarBorder: 'oklch(0.94 0.005 80)',
			sidebarRing: 'oklch(0.77 0 0)',
		},
		dark: {
			// Primary colors
			primaryHue: 67.14,
			primary: 'oklch(0.92 0.05 67.14)',
			primaryForeground: 'oklch(0.20 0.02 201.14)',
			secondary: 'oklch(0.32 0.02 67.00)',
			secondaryHue: 67.0,
			secondaryForeground: 'oklch(0.92 0.05 67.14)',
			// Background colors
			background: 'oklch(0.16 0.005 60)',
			foreground: 'oklch(0.95 0 0)',
			card: 'oklch(0.22 0.005 60)',
			cardForeground: 'oklch(0.95 0 0)',
			// Accent colors
			accent: 'oklch(0.28 0.005 60)',
			accentForeground: 'oklch(0.95 0 0)',
			muted: 'oklch(0.26 0.005 60)',
			mutedForeground: 'oklch(0.65 0.01 60)',
			// Border & input
			border: 'oklch(1 0 0 / 0.045)',
			input: 'oklch(1 0 0 / 0.045)',
			ring: 'oklch(0.92 0.05 67.14)',
			// Sidebar colors
			sidebar: 'oklch(0.20 0.005 60)',
			sidebarBg: 'oklch(0.24 0.005 60)',
			sidebarForeground: 'oklch(0.97 0 0)',
			sidebarPrimary: 'oklch(0.49 0.22 264.43)',
			sidebarPrimaryForeground: 'oklch(1.00 0 0)',
			sidebarAccent: 'oklch(0.28 0.005 60)',
			sidebarAccentForeground: 'oklch(0.97 0 0)',
			sidebarBorder: 'oklch(1 0 0 / 0.045)',
			sidebarRing: 'oklch(0.87 0.01 286.27)',
		},
	},
	{
		id: 'corporate',
		name: 'Corporate',
		light: {
			// Primary colors — refined indigo, less saturated
			primaryHue: 265,
			primary: 'oklch(0.45 0.14 265)',
			primaryForeground: 'oklch(1.00 0 0)',
			secondary: 'oklch(0.93 0.008 265)',
			secondaryHue: 265,
			secondaryForeground: 'oklch(0.35 0.03 265)',
			// Background colors — barely tinted cool gray
			background: 'oklch(0.97 0.004 265)',
			foreground: 'oklch(0.22 0.015 265)',
			card: 'oklch(0.98 0.003 265)',
			cardForeground: 'oklch(0.22 0.015 265)',
			// Accent colors
			accent: 'oklch(0.94 0.006 265)',
			accentForeground: 'oklch(0.22 0.015 265)',
			muted: 'oklch(0.94 0.006 265)',
			mutedForeground: 'oklch(0.55 0.012 265)',
			// Border & input
			border: 'oklch(0.92 0.004 265)',
			input: 'oklch(0.92 0.004 265)',
			ring: 'oklch(0.45 0.14 265)',
			// Sidebar colors
			sidebar: 'oklch(0.98 0.003 265)',
			sidebarBg: 'oklch(0.93 0.006 265)',
			sidebarForeground: 'oklch(0.22 0.015 265)',
			sidebarPrimary: 'oklch(0.45 0.14 265)',
			sidebarPrimaryForeground: 'oklch(1.00 0 0)',
			sidebarAccent: 'oklch(0.94 0.006 265)',
			sidebarAccentForeground: 'oklch(0.45 0.14 265)',
			sidebarBorder: 'oklch(0.93 0.006 265)',
			sidebarRing: 'oklch(0.45 0.14 265)',
		},
		dark: {
			// Primary colors — brighter indigo for dark
			primaryHue: 265,
			primary: 'oklch(0.65 0.15 265)',
			primaryForeground: 'oklch(1.00 0 0)',
			secondary: 'oklch(0.30 0.02 265)',
			secondaryHue: 265,
			secondaryForeground: 'oklch(0.93 0.005 265)',
			// Background colors
			background: 'oklch(0.16 0.008 265)',
			foreground: 'oklch(0.93 0.005 265)',
			card: 'oklch(0.22 0.008 265)',
			cardForeground: 'oklch(0.93 0.005 265)',
			// Accent colors
			accent: 'oklch(0.28 0.012 265)',
			accentForeground: 'oklch(0.93 0.005 265)',
			muted: 'oklch(0.26 0.01 265)',
			mutedForeground: 'oklch(0.65 0.012 265)',
			// Border & input
			border: 'oklch(1 0 0 / 0.045)',
			input: 'oklch(1 0 0 / 0.045)',
			ring: 'oklch(0.65 0.15 265)',
			// Sidebar colors
			sidebar: 'oklch(0.20 0.008 265)',
			sidebarBg: 'oklch(0.24 0.008 265)',
			sidebarForeground: 'oklch(0.93 0.005 265)',
			sidebarPrimary: 'oklch(0.65 0.15 265)',
			sidebarPrimaryForeground: 'oklch(1.00 0 0)',
			sidebarAccent: 'oklch(0.28 0.012 265)',
			sidebarAccentForeground: 'oklch(0.93 0.005 265)',
			sidebarBorder: 'oklch(1 0 0 / 0.045)',
			sidebarRing: 'oklch(0.65 0.15 265)',
		},
	},
	{
		id: 'spotify',
		name: 'Spotify',
		light: {
			// Primary colors — softer teal-green
			primaryHue: 160,
			primary: 'oklch(0.52 0.12 160)',
			primaryForeground: 'oklch(0.99 0 0)',
			secondary: 'oklch(0.93 0.008 160)',
			secondaryHue: 160,
			secondaryForeground: 'oklch(0.35 0.02 160)',
			// Background colors — neutral with subtle warm tint
			background: 'oklch(0.97 0.003 155)',
			foreground: 'oklch(0.22 0.01 160)',
			card: 'oklch(0.98 0.002 155)',
			cardForeground: 'oklch(0.22 0.01 160)',
			// Accent colors — harmonized with green
			accent: 'oklch(0.94 0.006 160)',
			accentForeground: 'oklch(0.22 0.01 160)',
			muted: 'oklch(0.94 0.006 160)',
			mutedForeground: 'oklch(0.55 0.012 160)',
			// Border & input
			border: 'oklch(0.92 0.004 155)',
			input: 'oklch(0.92 0.004 155)',
			ring: 'oklch(0.52 0.12 160)',
			// Sidebar colors
			sidebar: 'oklch(0.98 0.002 155)',
			sidebarBg: 'oklch(0.93 0.006 160)',
			sidebarForeground: 'oklch(0.22 0.01 160)',
			sidebarPrimary: 'oklch(0.52 0.12 160)',
			sidebarPrimaryForeground: 'oklch(0.99 0 0)',
			sidebarAccent: 'oklch(0.94 0.006 160)',
			sidebarAccentForeground: 'oklch(0.22 0.01 160)',
			sidebarBorder: 'oklch(0.92 0.006 160)',
			sidebarRing: 'oklch(0.52 0.12 160)',
		},
		dark: {
			// Primary colors — brighter green for dark
			primaryHue: 160,
			primary: 'oklch(0.65 0.13 160)',
			primaryForeground: 'oklch(0.15 0.01 160)',
			secondary: 'oklch(0.30 0.015 160)',
			secondaryHue: 160,
			secondaryForeground: 'oklch(0.93 0.005 155)',
			// Background colors — dark with subtle green
			background: 'oklch(0.15 0.006 160)',
			foreground: 'oklch(0.93 0.005 155)',
			card: 'oklch(0.21 0.006 160)',
			cardForeground: 'oklch(0.93 0.005 155)',
			// Accent colors
			accent: 'oklch(0.27 0.01 160)',
			accentForeground: 'oklch(0.93 0.005 155)',
			muted: 'oklch(0.25 0.008 160)',
			mutedForeground: 'oklch(0.63 0.012 160)',
			// Border & input
			border: 'oklch(1 0 0 / 0.045)',
			input: 'oklch(1 0 0 / 0.045)',
			ring: 'oklch(0.65 0.13 160)',
			// Sidebar colors
			sidebar: 'oklch(0.19 0.006 160)',
			sidebarBg: 'oklch(0.24 0.006 160)',
			sidebarForeground: 'oklch(0.93 0.005 155)',
			sidebarPrimary: 'oklch(0.65 0.13 160)',
			sidebarPrimaryForeground: 'oklch(0.15 0.01 160)',
			sidebarAccent: 'oklch(0.27 0.01 160)',
			sidebarAccentForeground: 'oklch(0.93 0.005 155)',
			sidebarBorder: 'oklch(1 0 0 / 0.045)',
			sidebarRing: 'oklch(0.65 0.13 160)',
		},
	},
	{
		id: 'ghibli',
		name: 'Ghibli',
		light: {
			// Primary colors — soft forest green
			primaryHue: 130,
			primary: 'oklch(0.55 0.08 130)',
			primaryForeground: 'oklch(0.98 0 0)',
			secondary: 'oklch(0.93 0.015 80)',
			secondaryHue: 80,
			secondaryForeground: 'oklch(0.45 0.03 80)',
			// Background colors — gentle warm, much less saturated
			background: 'oklch(0.96 0.012 80)',
			foreground: 'oklch(0.30 0.03 60)',
			card: 'oklch(0.97 0.01 80)',
			cardForeground: 'oklch(0.30 0.03 60)',
			// Accent colors
			accent: 'oklch(0.93 0.015 80)',
			accentForeground: 'oklch(0.30 0.03 60)',
			muted: 'oklch(0.93 0.015 80)',
			mutedForeground: 'oklch(0.52 0.03 70)',
			// Border & input
			border: 'oklch(0.90 0.01 80)',
			input: 'oklch(0.90 0.01 80)',
			ring: 'oklch(0.55 0.08 130)',
			// Sidebar colors
			sidebar: 'oklch(0.97 0.01 80)',
			sidebarBg: 'oklch(0.92 0.015 80)',
			sidebarForeground: 'oklch(0.30 0.03 60)',
			sidebarPrimary: 'oklch(0.55 0.08 130)',
			sidebarPrimaryForeground: 'oklch(0.98 0 0)',
			sidebarAccent: 'oklch(0.93 0.015 80)',
			sidebarAccentForeground: 'oklch(0.30 0.03 60)',
			sidebarBorder: 'oklch(0.91 0.01 80)',
			sidebarRing: 'oklch(0.55 0.08 130)',
		},
		dark: {
			// Primary colors — muted sage for dark
			primaryHue: 130,
			primary: 'oklch(0.65 0.07 130)',
			primaryForeground: 'oklch(0.98 0 0)',
			secondary: 'oklch(0.30 0.01 60)',
			secondaryHue: 60,
			secondaryForeground: 'oklch(0.88 0.01 80)',
			// Background colors — warm dark earth
			background: 'oklch(0.17 0.006 60)',
			foreground: 'oklch(0.90 0.01 80)',
			card: 'oklch(0.23 0.006 60)',
			cardForeground: 'oklch(0.90 0.01 80)',
			// Accent colors
			accent: 'oklch(0.28 0.008 60)',
			accentForeground: 'oklch(0.90 0.01 80)',
			muted: 'oklch(0.26 0.006 60)',
			mutedForeground: 'oklch(0.65 0.015 75)',
			// Border & input
			border: 'oklch(1 0 0 / 0.045)',
			input: 'oklch(1 0 0 / 0.045)',
			ring: 'oklch(0.65 0.07 130)',
			// Sidebar colors
			sidebar: 'oklch(0.21 0.006 60)',
			sidebarBg: 'oklch(0.25 0.006 60)',
			sidebarForeground: 'oklch(0.90 0.01 80)',
			sidebarPrimary: 'oklch(0.65 0.07 130)',
			sidebarPrimaryForeground: 'oklch(0.98 0 0)',
			sidebarAccent: 'oklch(0.28 0.008 60)',
			sidebarAccentForeground: 'oklch(0.90 0.01 80)',
			sidebarBorder: 'oklch(1 0 0 / 0.045)',
			sidebarRing: 'oklch(0.65 0.07 130)',
		},
	},
]

export function getSchemeById(id: string): ColorScheme | undefined {
	return colorSchemes.find((scheme) => scheme.id === id)
}

export function getDefaultScheme(): ColorScheme {
	return colorSchemes[0]
}
